var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group',{staticClass:"list-group list-group-flush"},[_c('b-list-group-item',{class:_vm.infotype,attrs:{"variant":"sideNav"}},[_c('i',{staticClass:"fas",class:_vm.icon}),_c('div',[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }